export default "__VITE_ASSET__DY3pvzx4__"